import { Result } from '@team23/ts-result';
import { Configuration } from '../api';
import { Environment, EnvironmentStatus } from '@ui/shared/util-config';

export const apiConfigurationFactory =
    (environmentService: { environment: Result<Environment, EnvironmentStatus> }): Configuration =>
        new Configuration({ basePath: environmentService.environment.data?.apiBasePath });
